<template>
  <div class="download-report-wrapper">
    <headView :option="title" :subtitleOpt="subtitleOpt"></headView>
    <div class="download-report__content">
      <h3>Descarga de reporte histórico</h3>
      <!-- <input
        class="input-date"
        type="text"
        id="datepicker-trigger-download"
        placeholder="Seleccione las fechas"
        :value="formatDates(dateOne)"
      /> -->
      <!-- <AirbnbStyleDatepicker
        :trigger-element-id="'datepicker-trigger-download'"
        mode="single"
        :date-one="dateOne"
        @date-one-selected="val => { dateOne = val }"
        @apply="changeDate"
        :monthsToShow="1"
        :fullscreenMobile="true"
      /><br> -->
      <vue-monthly-picker
        v-model="selectedMonth" placeHolder="Elija el mes"
        :monthLabels="monthLabels" dateFormat="MMMM YYYY" alignment="center" @selected="changeDate($event)">
      </vue-monthly-picker>
      <button class="download-button" @click="download">Descagar Reporte</button>
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import format from "date-fns/format";
import VueMonthlyPicker from 'vue-monthly-picker'
import {mapGetters} from "vuex"
export default {
  name: "DownloadReports",
  components: {
    headView, VueMonthlyPicker
  },
  data() {
    return {
      title: {
        headText: "Descargar Reportes",
        subtitle: ""
      },
      subtitleOpt: false,
      dateOne: null,
      dateFormat: "MMM YYYY",
      selectedMonth: null,
      monthLabels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio","Julio","Agosto","Setiembre","Octubre","Noviembre","Diciembre"]
    };
  },
  created(){
    console.log(this.currentUser);
    
  },
  computed: {
    ...mapGetters(["currentUser"]),
    // monthSelected(){
    //   if(!this.dateOne) return new Date().setDate(0)
    //   return new Date(this.dateOne).setDate(0)
    // }
  },
  methods: {
    changeDate($ev) {
      console.log($ev);
    },
    formatDates(dateOne) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      return formattedDates;
    },
    download(){
      if(this.selectedMonth){
        return window.open(`${this.currentUser.reportDownloadLink}&startDate=${new Date(this.selectedMonth._d).toISOString()}&namespace=${this.$store.state.namespace}`, "_blank");
      }else {
        this.$toast.open({
          message: "Tiene que elegir un mes",
          position: "is-bottom-right",
          type: "ffcolor-is-delete"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/1.settings/variables.scss";
.download-report-wrapper {
  margin-top: 100px;
}
.input-date {
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  border: thin solid #00a699;
  text-align: center;
  margin: 1rem auto;
}
.asd__wrapper {
  top: 160px !important;
  right: 175px !important;
}
.download-button{
  padding: 8px 32px;
    font-size: 16px;
    border: thin solid $colorButtonOk; 
    background-color: $colorButtonOk;
    color: #ffffff;
    margin: 0.5rem auto;
    cursor: pointer;
    &:hover, &:focus{
      border: thin solid $colorButtonOk;
      background-color: #ffffff;
      color: $colorButtonOk;
    }
}
.vue-monthly-picker{
  width: 350px;
  margin: 0.5rem auto;
}
.month-picker-input{
  border: thin solid $colorButtonOk;
      background-color: #ffffff;
      color: $colorButtonOk;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/DownloadReports.vue